import type { ReactNode } from 'react';
import { Gauge, Link2, TrendingUp } from 'lucide-react';
import { BrandIcon } from '@/components/ui';
import type { IntegrationKind } from '@/types/api';

/** A service's mark where it has one in Simple Icons; a plain icon for the rest. */
export function IntegrationMark({ kind, size = 16 }: { readonly kind: IntegrationKind; readonly size?: number }): ReactNode {
  switch (kind) {
    case 'google':
      return <BrandIcon name="googlesearchconsole" size={size} />;
    case 'anthropic':
      return <BrandIcon name="claude" size={size} />;
    case 'ahrefs':
      return <TrendingUp size={size} aria-hidden="true" />;
    case 'dataforseo':
      return <Link2 size={size} aria-hidden="true" />;
    case 'openpagerank':
      return <Gauge size={size} aria-hidden="true" />;
  }
}
